import { useLazyRef, χref } from '@studio/react-utils/hooks';
import { freeze } from 'immer';
import type { ReactElement } from 'react';
import { createWithEqualityFn as create } from 'zustand/traditional';
import { immer } from 'zustand/middleware/immer';
import { Context } from './context.js';
import type { Draft, Props, State, Store } from './types.js';
import { toCandidate } from '#~/device/index.js';

/** Audio settings workflow `<Provider>`. */
export const Provider = ({ children, device }: Props): ReactElement => {
  const store = useLazyRef<Store>(() =>
    create<State>()(
      immer((set) =>
        freeze({
          candidate: toCandidate(device),
          isReady: false,
          produce: (fn: (draft: Draft) => void): void => {
            set(fn);
          }
        })
      )
    )
  );

  return <Context.Provider value={χref(store)}>{children}</Context.Provider>;
};
